import FancyCard from '../../../components/fancy/FancyCard';
import { CardContent, Grid } from '@material-ui/core';
import React from 'react';

export const NoGuestPayment = ({ noMethods = false }) => {
    if (noMethods) {
        return (
            <Grid item xs={12}>
                <FancyCard fullWidth>
                    <CardContent>
                        No payment methods are available. Please contact support.
                    </CardContent>
                </FancyCard>
            </Grid>
        );
    }
    return (
        <Grid item xs={12}>
            <FancyCard fullWidth>
                <CardContent>
                    <h3>Visit the concierge desk to do reservations!</h3>
                </CardContent>
            </FancyCard>
        </Grid>
    );
};
